import { createSlice } from '@reduxjs/toolkit';

export type EmailQuoteState = {
  isLoading: boolean;
  errors: null | [];
  details: {
    firstName: string;
    lastName: string;
    email: string;
  };
  data: Record<string, unknown>;
};

export const initialState: EmailQuoteState = {
  isLoading: false,
  errors: null,
  details: {
    firstName: '',
    lastName: '',
    email: ''
  },
  data: {}
};

export const slice = createSlice({
  name: 'emailQuote',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    },
    setFormField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setFormField,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectDetails = (state) => selectSlice(state).details;
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;
export const selectData = (state) => selectSlice(state).data;

export default slice.reducer;
